import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/components/Select';
import { trackDdgUsageEvents } from '../utils/usageTracking';
import { INDUSTRIES } from '../constants/industries';
import { jsx as _jsx } from "react/jsx-runtime";
export function IndustrySelector({
  value,
  onChange
}) {
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockEnd: "500",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "partnerDemoPortalUi.industry.label"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "partnerDemoPortalUi.industry.help"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "industry-selector",
      selectedItemsPlaceholder: I18n.text('partnerDemoPortalUi.industry.placeholder'),
      options: INDUSTRIES.map(key => ({
        text: I18n.text(`partnerDemoPortalUi.industry.options.${key}`),
        value: key
      })),
      selectedValues: value ? [value] : [],
      onSelectedOptionChange: evt => {
        const newIndustry = evt.value || undefined;
        if (newIndustry) {
          trackDdgUsageEvents({
            action: 'industry-selected',
            screen: 'demo-data-generator',
            industry: newIndustry
          });
        }
        onChange(newIndustry);
      }
    })
  });
}